/* "Zuletzt angeschaut" des Weissblau-Themes.
 *
 * Der Verlauf liegt im Browser (localStorage), nicht am Kunden - er soll ohne Anmeldung
 * funktionieren und keine Daten an den Server schicken. Gemerkt wird nur das Handle.
 *
 * Gefuellt wird er zweifach:
 *  - auf einer Produktseite traegt sich der Artikel beim Oeffnen selbst ein
 *    (window.mhsysVerlauf.merken('<handle>') aus der Produktvorlage)
 *  - ein Klick auf eine Kachel merkt das Produkt schon vor dem Seitenwechsel
 *    (Elemente mit data-mhsys-verlauf="<handle>")
 *
 * Die Karten kommen aus Liquid (sections/mhsys-verlauf-karten.liquid ueber die Shop-Suche, ein
 * Abruf fuer alle), damit Preis und Bild nicht in JavaScript nachgebaut werden. Geloeschte oder
 * versteckte Produkte liefert die Suche nicht - die Karte entfaellt still (08 B5).
 */
(() => {
  'use strict';

  const SCHLUESSEL = 'mhsysVerlauf';
  const MAX = 12;
  /* Nie im Verlauf: die Express-Bearbeitung ist eine Leistung, kein Produkt zum Stoebern (Roadmap 3.107, Inhaber
     09.10.2026) - Handle wie wk_express_handle in snippets/mhsys-warenkorb.liquid. Auch schon gemerkte fallen beim Lesen weg. */
  const NIE = ['express-bearbeitung'];

  function lesen() {
    try {
      const roh = localStorage.getItem(SCHLUESSEL);
      const liste = roh ? JSON.parse(roh) : [];
      return Array.isArray(liste) ? liste.filter((h) => typeof h === 'string' && !NIE.includes(h)).slice(0, MAX) : [];
    } catch (e) {
      /* Privates Fenster oder gesperrter Speicher: der Bereich bleibt einfach leer */
      return [];
    }
  }

  function schreiben(liste) {
    try {
      localStorage.setItem(SCHLUESSEL, JSON.stringify(liste.slice(0, MAX)));
    } catch (e) {}
  }

  function merken(handle) {
    if (!handle || NIE.includes(handle)) return;
    const liste = lesen().filter((h) => h !== handle);
    liste.unshift(handle);
    schreiben(liste);
  }

  window.mhsysVerlauf = { merken, lesen };

  /* Klick auf eine Kachel merkt das Produkt, bevor die neue Seite laedt */
  document.addEventListener(
    'click',
    (e) => {
      const el = e.target.closest('[data-mhsys-verlauf]');
      if (el) merken(el.dataset.mhsysVerlauf);
    },
    true
  );

  /* Ein Abruf je Seite: das Ergebnis wird je URL gemerkt (auch wenn der Theme-Editor die Section neu
     einsetzt oder mehrere Instanzen auf der Seite stehen) */
  const abrufe = {};
  function kartenHolen(handles) {
    const suche = (window.mhsysShop && window.mhsysShop.suchUrl) || '/search';
    const frage = handles.map((h) => `handle:"${h.replace(/"/g, '')}"`).join(' OR ');
    const url = `${suche}?type=product&q=${encodeURIComponent(frage)}&section_id=mhsys-verlauf-karten`;
    if (!abrufe[url]) {
      abrufe[url] = fetch(url)
        .then((r) => (r.ok ? r.text() : ''))
        .catch(() => '');
    }
    return abrufe[url];
  }

  /* Steht der helle Verlauf sichtbar im Fuss, bekommen Toleranztext und Fuss-Silhouette seinen Grund (mhsys-weissblau.css).
     Als Klasse am <html> statt html:has(... :not([hidden])) - die Pruefung lief bei jeder DOM-Aenderung ueber die ganze
     Seite (Performance-Check 05.10.2026). */
  function hellMelden() {
    const an = !!document.querySelector('.mhsys-verlauf--fuss.mhsys-verlauf--hell:not([hidden])');
    if (document.documentElement.classList.contains('mhsys-verlauf-hell') !== an) document.documentElement.classList.toggle('mhsys-verlauf-hell', an);
  }

  function fuellen() {
    /* Der Baustein kann in einer Vorlage stehen (Startseite, "MHSys Zuletzt angeschaut") und steht in der
       Fussgruppe. Gibt es einen in der Seite, bleibt der im Fuss weg - nie zweimal derselbe Verlauf. */
    const alle = [...document.querySelectorAll('[data-mhsys-verlauf-bereich]')];
    if (!alle.length) return;
    const inSeite = alle.filter((b) => b.dataset.mhsysVerlaufOrt !== 'fuss');
    const bereiche = inSeite.length ? inSeite : alle;
    alle.forEach((b) => {
      if (!bereiche.includes(b)) b.hidden = true;
    });

    const leeren = () => {
      schreiben([]);
      bereiche.forEach((b) => {
        const s = b.querySelector('[data-mhsys-verlauf-spur]');
        if (s) s.replaceChildren();
        b.hidden = true;
      });
      hellMelden();
    };
    bereiche.forEach((b) => {
      const knopf = b.querySelector('[data-mhsys-verlauf-leeren]');
      if (knopf && !knopf.dataset.mhsysBereit) {
        knopf.dataset.mhsysBereit = '1';
        knopf.addEventListener('click', leeren);
      }
    });

    /* Den aktuell offenen Artikel nicht in seinem eigenen Verlauf zeigen. Geholt wird die groesste
       gewuenschte Anzahl, jede Instanz zeigt ihre eigene. */
    const aktuell = (bereiche[0].dataset.mhsysAktuell || '').trim();
    const anzahlVon = (b) => parseInt(b.dataset.mhsysAnzahl, 10) || MAX;
    /* Alle gemerkten (hoechstens 12) holen, nicht nur die Zielanzahl: faellt eine Karte weg (Tag "Unwichtig",
       nicht mehr veroeffentlicht), rueckt die naechste nach */
    const handles = lesen().filter((h) => h !== aktuell);
    if (!handles.length) {
      bereiche.forEach((b) => (b.hidden = true));
      hellMelden();
      return;
    }

    /* EIN Abruf fuer alle Karten ueber die Shop-Suche (handle:"…" OR …) statt je Karte einen -
       vorher bis zu 12 Abrufe je Seitenaufruf (Funktionstest 18.09.2026) */
    kartenHolen(handles).then((html) => {
      const karten = {};
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-mhsys-verlauf-karte]').forEach((k) => {
          karten[k.dataset.mhsysHandle] = k;
        });
      }
      bereiche.forEach((b) => {
        const spur = b.querySelector('[data-mhsys-verlauf-spur]');
        if (!spur) return;
        /* In der Reihenfolge des Verlaufs, nicht der Suche; je Instanz eigene Kopien */
        const bruch = document.createDocumentFragment();
        const ohneUnwichtig = b.hasAttribute('data-mhsys-ohne-unwichtig');
        handles
          .filter((h) => karten[h] && !(ohneUnwichtig && karten[h].hasAttribute('data-mhsys-unwichtig')))
          .slice(0, anzahlVon(b))
          .forEach((h) => bruch.appendChild(document.importNode(karten[h], true)));
        if (!bruch.childElementCount) {
          b.hidden = true;
          return;
        }
        spur.replaceChildren(bruch);
        b.hidden = false;
        pfeileVerbinden(b, spur);
      });
      hellMelden();
    });
  }

  /* Kein sichtbarer Scrollbalken mehr - am Desktop zeigen Pfeile, dass es weitergeht. Sie
     erscheinen nur, wenn die Spur breiter ist als ihr Platz, und sperren sich am Anfang/Ende. */
  function pfeileVerbinden(bereich, spur) {
    const zurueck = bereich.querySelector('[data-mhsys-verlauf-zurueck]');
    const weiter = bereich.querySelector('[data-mhsys-verlauf-weiter]');
    const pfeile = bereich.querySelector('[data-mhsys-verlauf-pfeile]');
    if (!zurueck || !weiter || !pfeile) return;
    const pruefen = () => {
      const mehr = spur.scrollWidth > spur.clientWidth + 2;
      pfeile.hidden = !mehr;
      zurueck.disabled = spur.scrollLeft <= 2;
      weiter.disabled = spur.scrollLeft + spur.clientWidth >= spur.scrollWidth - 2;
    };
    if (!pfeile.dataset.mhsysBereit) {
      pfeile.dataset.mhsysBereit = '1';
      const schritt = () => Math.max(200, Math.round(spur.clientWidth * 0.8));
      zurueck.addEventListener('click', () => spur.scrollBy({ left: -schritt(), behavior: 'smooth' }));
      weiter.addEventListener('click', () => spur.scrollBy({ left: schritt(), behavior: 'smooth' }));
      spur.addEventListener('scroll', pruefen, { passive: true });
      window.addEventListener('resize', pruefen, { passive: true });
    }
    pruefen();
  }

  /* Produktbaender mit anderer Quelle (sections/mhsys-verlauf.liquid): Kollektion und freie Auswahl stehen schon
     im HTML - sie brauchen nur die Pfeile. Empfehlungen ohne mhsys-Metafeld kommen in EINEM Abruf von Shopify
     (data-mhsys-band-nachladen), das Band bleibt bis dahin versteckt. Mit dem Verlauf haben sie nichts zu tun:
     sie zaehlen nicht bei "steht einer in der Seite, bleibt der im Fuss weg". */
  function baenderVerbinden() {
    document.querySelectorAll('[data-mhsys-produktband]:not([data-mhsys-verlauf-bereich])').forEach((b) => {
      const spur = b.querySelector('[data-mhsys-verlauf-spur]');
      if (!spur) return;
      const url = b.dataset.mhsysBandNachladen;
      if (!url) {
        pfeileVerbinden(b, spur);
        return;
      }
      if (b.dataset.mhsysBereit) return;
      b.dataset.mhsysBereit = '1';
      fetch(url)
        .then((r) => (r.ok ? r.text() : ''))
        .catch(() => '')
        .then((html) => {
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const anzahl = parseInt(b.dataset.mhsysAnzahl, 10) || MAX;
          const ohneUnwichtig = b.hasAttribute('data-mhsys-ohne-unwichtig');
          const karten = [...doc.querySelectorAll('[data-mhsys-verlauf-karte]')]
            .filter((k) => !(ohneUnwichtig && k.hasAttribute('data-mhsys-unwichtig')))
            .slice(0, anzahl);
          if (!karten.length) return;
          spur.replaceChildren(...karten.map((k) => document.importNode(k, true)));
          b.hidden = false;
          pfeileVerbinden(b, spur);
        });
    });
  }

  function start() {
    fuellen();
    hellMelden();
    baenderVerbinden();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
